module.exports = __webpack_public_path__ + "media/images/top/img_pickup_muteppou-ab0bd0a0ee604a736ff6da7330cd0f3c.webp";